export default {
  CODE: 'code',
  ENGLISH: 'en',
  ESTONIAN: 'et',
  LANG: 'lang',
};
